import injectionCode from '../../../preview/advanced-checkout'

const type = 'advanced'
const path = 'client/react'
const name = 'index.html'
const fullPath = `${path}/${name}`

export { type, path, name, fullPath, injectionCode }
